module.exports = __webpack_public_path__ + "img/white-plus.svg";